import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/QualityPage.css";

const QualityPage = () => {
  return (
    <>
      <Header />

      <section
        className="quality-banner"
        style={{
          backgroundImage:
            "url('/wp-content/uploads/2016/02/Quality-Page.png')",
        }}
      ></section>

      <div className="quality-wrapper">
        <div className="center-container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Quality</span>
          </div>

          <h1 className="page-title">
            Quality
          </h1>

          <div className="quality-content">
            <p className="quality-text">
              Maintaining extreme Quality standards in all our product offerings
              is an integrated part of Colombo Dockyard's corporate philosophy.
              We ensure that documentation systems that are in compliance with
              international quality standards are maintained at all levels
              within the Company.
            </p>

            <p
              className="quality-subtitle"
            >
              <strong>
                Colombo Dockyard has received its Quality Management
                accreditations and certification standards over the years, as
                follows:
              </strong>
            </p>

            <ul
              className="quality-list"
            >
              <li>
                <strong>ISO 9001:1994</strong> International Standards for
                Quality Management Systems in 1999
              </li>
              <li>
                <strong>ISO 9001:2000</strong> International Standards for
                Quality Management Systems in 2002
              </li>
              <li>
                <strong>ISO 9001:2008</strong> International Standards for
                Quality Management Systems in 2010
              </li>
              <li>
                <strong>ISO 9001:2015</strong> International Standards for
                Quality Management Systems in 2017
              </li>
            </ul>

            <p className="quality-text">
              Colombo Dockyard's Quality Manual, Quality Procedure Manual and
              Work Instructions, all play an important role in keeping us
              focused on maintaining quality standards in all of the work that
              we do.
            </p>

            <p className="quality-text">
              Annual external audit is carried out by LRQA and all quality
              management system applications are audited by a panel of qualified
              internal auditors.
            </p>

            <div className="quality-certificate">
              <a
                href="/wp-content/uploads/2023/08/ISO-9001-2015-QMS-Certificate.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/wp-content/uploads/2023/08/LRQA.jpg"
                  alt="ISO 9001:2015 Certificate"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default QualityPage;
